<template>
    <svg class="icon-podcast-series fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.38 14.265">
        <path d="M23.38,14.265H9.12V0H23.38V14.264ZM11.635,2.52h0v9.227h9.227V2.52Z" />
        <rect x="4.5" y="0" width="2.5" height="14.265" />
        <rect y="0" width="2.5" height="14.265" />
        <path d="M18.862,7.132l-5.224,3.1v-6.2Z" />
    </svg>
</template>
